'use strict';

const jQuery = require('jquery');
const PasswordValidator = require('password-validator');

const Zone = require('./../../../../services/structure/zone');
const Translator = require('./../../../../core/translator');
const Notifier = require('./../../../../services/notifier');
const Container = require('./../../../../core/container');
const FormBuilder = require('./../../../../services/form');
const ListItem = require('./../../../../services/listItem');
const PopinManager = require('./../../../../services/popin');

const UserRepository = require('./../../repository/UserRepository');
const GroupRepository = require('./../../repository/GroupRepository');

const ListTpl = require('./template/list.hbs');

const showForm = (data = null) => {
  let user = data || {};
  let isNew = !data;
  let $tpl = jQuery('<div class="mt-3" />');

  GroupRepository.findBy().done((groupsTypeList) => {
    let config = {
      'elements': {
        'firstname': {
          'type': 'text',
          'label': Translator.translate('firstname'),
          'value': user.firstname,
        },
        'lastname': {
          'type': 'text',
          'label': Translator.translate('lastname'),
          'value': user.lastname,
        },
        'email': {
          'type': 'text',
          'label': Translator.translate('email'),
          'disabled': !isNew,
          'autocomplete': false,
          'value': user.email,
        },
        'password': {
          'type': 'password',
          'label': Translator.translate('enter_password'),
          'autocomplete': false,
          'value': '',
          'onChange': function(e) {
            let $input = jQuery(e.currentTarget);
            let $panel = $input.parents('form:first').find('.pw-format-wrapper');
            let val = $input.val();

            let schema1 = new PasswordValidator().isMin(8);
            $panel.find('[data-format="1"]').find('i').attr('class', `icon ${val && schema1.validate(val) ? 'icon-check-circle' : 'icon-plus-circle'}`);

            let schema2 = new PasswordValidator().has().uppercase();
            $panel.find('[data-format="2"]').find('i').attr('class', `icon ${val && schema2.validate(val) ? 'icon-check-circle' : 'icon-plus-circle'}`);

            let schema3 = new PasswordValidator().has().lowercase();
            $panel.find('[data-format="3"]').find('i').attr('class', `icon ${val && schema3.validate(val) ? 'icon-check-circle' : 'icon-plus-circle'}`);

            let schema4 = new PasswordValidator().has().symbols();
            $panel.find('[data-format="4"]').find('i').attr('class', `icon ${val && schema4.validate(val) ? 'icon-check-circle' : 'icon-plus-circle'}`);
          },
        },
        'confirm_new_password': {
          'type': 'password',
          'label': Translator.translate('confirm_password'),
          'autocomplete': false,
          'value': '',
        },
        'group_types': {
          'type': 'select',
          'renderType': 'list',
          'defaultOption': Translator.translate('choose_group'),
          'label': Translator.translate('add_group'),
          'onDelete': function(item, deleteFunc) {
            let popin = PopinManager.createPopin({
              'title': Translator.translate('remove_group_from_user_modal'),
              'minHeight': 50,
              'buttons': [
                {
                  class: 'popin popin-cancel',
                  text: Translator.translate('discard'),
                  click: function() {
                    popin.hide();
                  },
                },
                {
                  text: Translator.translate('remove'),
                  click: function() {
                    deleteFunc();
                    Notifier.success(Translator.translate('remove_group_from_user_confirmed'));

                    popin.hide();
                  },
                },
              ],
            });

            Container.set('prevent-hide-toolbar', true);
            Container.set('prevent-hide-overlay', true);
            popin.on('close', function() {
              setTimeout(function() {
                Container.set('prevent-hide-toolbar', false);
                Container.set('prevent-hide-overlay', false);
              }, 100);
            });

            let content = Translator.translate('remove_group_from_user_confirm', {
              userName: user.name,
              groupName: Translator.translate(item.name),
            });

            popin.setContent(`<p>${content}</p>`);
            popin.display();
          },
          'options': function() {
            let groups = {};

            groupsTypeList.forEach((group) => {
              groups[group.id] = group.name;
            });

            return groups;
          }(),
          'value': function() {
            let values = [];
            let groupTypes = user['group_types'] || [];

            groupTypes.forEach((groupId) => {
              let groupType = groupsTypeList.find((group) => {
                return group.id === groupId;
              });

              if (groupType) {
                values.push(groupType);
              }
            });

            return values;
          }(),
        },
      },
      'form': {
        'autocomplete': false,
        'submit_label': Translator.translate('save'),
      },
    };

    if (!isNew) {
      delete config.elements.password;
      delete config.elements['confirm_new_password'];
    }

    let form = FormBuilder.getForm(config);

    form.on('validate', (submitData) => {
      if (!submitData.firstname) {
        form.addError('firstname', Translator.translate('empty_error'));
      }

      if (!submitData.lastname) {
        form.addError('lastname', Translator.translate('empty_error'));
      }

      if (submitData.group_types.length === 0) {
        form.addError('group_types', Translator.translate('group_management_no_group_selected_error'));
      }

      if (isNew) {
        let schema = new PasswordValidator().isMin(8).has().uppercase().has().lowercase().symbols();

        if (submitData['password'] !== submitData['confirm_new_password']) {
          form.addError('password', Translator.translate('error_password_same'));
          form.addError('confirm_new_password', Translator.translate('error_password_same'));
        }

        if (!submitData['password'] || !schema.validate(submitData['password'])) {
          form.addError('password', Translator.translate('error_password_format'));
          form.addError('confirm_new_password', Translator.translate('error_password_format'));
        }
      }
    });

    form.on('submit', (submitData) => {
      submitData.login = submitData.email;

      UserRepository.save(submitData, user.id || null).done(function() {
        showList();
        Notifier.success(Translator.translate('recorded'));
      }).fail(function() {
        form.addError('email', Translator.translate('email_exist_error'));
        form.displayErrors();
      });
    });

    $tpl.append(form.render());

    if (isNew) {
      $tpl.find('input[name=\'password\']').parent('.element_password').before(`
                <div class="pw-format-wrapper mb-2">
                    <p>${Translator.translate('error_password_format_description')} :</p>
                    <ul class="list-unstyled mb-0">
                        <li data-format="1"><i class="icon icon-plus-circle"></i> ${Translator.translate('error_password_format1')} </li>
                        <li data-format="2"><i class="icon icon-plus-circle"></i> ${Translator.translate('error_password_format2')} </li>
                        <li data-format="3"><i class="icon icon-plus-circle"></i> ${Translator.translate('error_password_format3')} </li>
                        <li data-format="4"><i class="icon icon-plus-circle"></i> ${Translator.translate('error_password_format4')} </li>
                    </ul>
                </div>
            `);
    }
  });

  Zone.setFullPanel(Translator.translate(`user_${isNew ? 'add' : 'edit'}`), $tpl);
};

const deleteUser = (user) => {
  let popin = PopinManager.createPopin({
    'title': Translator.translate('group_management_delete_user_modal'),
    'minHeight': 50,
    'buttons': [
      {
        class: 'popin popin-cancel',
        text: Translator.translate('discard'),
        click: function() {
          popin.hide();
        },
      },
      {
        text: Translator.translate('delete'),
        click: function() {
          UserRepository.delete(user.id).done(() => {
            Notifier.success(Translator.translate('group_management_delete_user_confirmed'));
            showList();
          });

          popin.hide();
        },
      },
    ],
  });

  Container.set('prevent-hide-toolbar', true);
  Container.set('prevent-hide-overlay', true);
  popin.on('close', function() {
    setTimeout(function() {
      Container.set('prevent-hide-toolbar', false);
      Container.set('prevent-hide-overlay', false);
    }, 100);
  });

  let content = Translator.translate('group_management_delete_user_confirm', {
    userName: user.name,
  });

  popin.setContent(`<p>${content}</p>`);
  popin.display();
};

const showList = () => {
  let $tpl = jQuery(ListTpl());
  let $list = $tpl.find('.user-list');
  let $searchInput = $tpl.find('input.input-search');
  const showUsers = (term = '') => {
    UserRepository.findBy({name: term}).done((users) => {
      $list.html('');
      users.forEach((user) => {
        if (user['is_removable']) {
          user.name = user.firstname + ' ' + user.lastname;
          let $item = ListItem.create({
            name: user.name,
            buttons: [
              {
                iconClass: 'icon-pencil',
                onClick: function() {
                  showForm(user);
                },
              },
              {
                iconClass: 'icon-times',
                onClick: function() {
                  deleteUser(user);
                },
              },
            ],
          });

          $list.append($item);
        }
      });
    });
  };

  showUsers();

  $searchInput.on('keyup', function(e) {
    showUsers(jQuery.trim($searchInput.val().replace(/[\/\\"]/gi, ' ')).replace(/\s+/g, ' '));
  });

  Zone.setFullPanel(Translator.translate('user_management'), $tpl);
};

module.exports.list = showList;
module.exports.createUser = showForm;
